<template>
  <div class="main-content-container">
    <div class="container">
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Links de Venda</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span
                v-if="countFilter > 0"
                class="badge badge-light"
              >{{countFilter}}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Links</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6
                  class="m-0"
                >{{pagination.TotalItems | number}} {{pagination.TotalItems > 1 ? " itens" : "item"}}</h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingLinkList"></loader>
              <table class="table mb-0" v-if="!loadingLinkList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Descrição</th>
                    <th scope="col" class="border-0">URL</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ListLink, index) in ListLinks" :key="index">
                    <td></td>
                    <td class="text-left td-with-subs">
                      <div>{{ListLink.Description}}</div>
                      <span
                        class="td-span-style"
                        v-if="ListLink.UserPartner.Name != null && ListLink.UserPartner.Name != undefined && ListLink.UserPartner.Name != ''"
                      >VENDEDOR {{ListLink.UserPartner.Name | upper}}</span>
                    </td>
                    <td class="text-center">
                      <popper
                        trigger="hover"
                        :options="{
                          placement: 'top',
                          modifiers: { offset: { offset: '0,10px' } }
                        }"
                      >
                        <div class="popper">{{textPopper}}</div>

                        <div
                          slot="reference"
                          v-on:click="CopyLink($event)"
                          v-on:mouseleave="ResetPopperText()"
                          class="form-control px-20px mb-10px cursor-pointer"
                        >
                          <span class="code text-red">{{ListLink.Identifier}}</span>
                        </div>
                      </popper>
                    </td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >Opções</button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            class="dropdown-item"
                            href="#"
                            v-on:click="GetLink($event, ListLink.Id, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            v-on:click="GetLink($event,ListLink.Id)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="RemoveLinkValidate(ListLink.Id)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-show="ListLinks == undefined || ListLinks.length == 0">
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-if="isDataReady" id="mFormLink" :title="modalTitle" centered>
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <ValidationObserver ref="formValidation">
          <div>
            <d-form-row>
              <d-col md="12" class="form-group">
                <label for="text">Descrição</label>
                <ValidationProvider rules="required" v-slot="{errors, invalid}">
                  <d-input
                    :class="validatedFormValidation | showValidateError(invalid)"
                    id="Description"
                    v-model="PartnerLink.Description"
                    :disabled="isSeeing && !isCreating"
                    type="text"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >{{ errors[0] }}</div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <d-form-row>
              <d-col md="12">
                <div class="form-group">
                  <label>Vendedor</label>
                  <d-select
                    v-model="PartnerLink.UserPartner.Id"
                    :value="0"
                    :disabled="isSeeing && !isCreating"
                  >
                    <option :value="0" selected>Selecione</option>
                    <option
                      v-for="user in users"
                      v-bind:value="user.Id"
                      v-bind:key="user.Id"
                    >{{user.Name}}</option>
                  </d-select>
                </div>
              </d-col>
            </d-form-row>
            <d-form-row v-if="isSeeing">
              <d-col md="12" class="form-group">
                <label>Data do cadastro</label>
                <d-form-input
                  type="text"
                  v-bind:value="PartnerLink.CreatedDate | date('DD/MM/YYYY - HH:mm')"
                  readonly
                />
              </d-col>
            </d-form-row>
          </div>
          <d-form-row>
            <d-col md="12">
              <h4>Taxas</h4>

              <div class="mb-5">
                <d-form-row>
                  <d-col class="text-left">
                    <label class="h5">{{ CommissionCompetences.BankSlip.Name }}</label>
                  </d-col>
                  <d-col class="text-right">
                    <span class="h5">Comissão</span>
                  </d-col>
                </d-form-row>
                <d-form-row>
                  <d-col md="3">
                    <label class="mb-0 tax-type">{{ CommissionCompetences.BankSlip.Taxes[0].TaxType.Id == 1 ? "Percentual (%)" : "Valor (R$)" }}</label>
                    <ValidationProvider 
                      :rules="{
                        required: true,
                        min_value: parseFloat(CommissionCompetences.BankSlip.Labels[0].replace(',', '.')),
                        max_value: parseFloat(CommissionCompetences.BankSlip.Labels[CommissionCompetences.BankSlip.Labels.length - 1].replace(',', '.')),
                      }" v-slot="{ errors, invalid }"
                    >
                      <decimal-field v-model="BankSlipTax" id="BankSlip" :disabled="isSeeing" class="link" :class="validatedTax | showValidateError(invalid)"
                        :type="CommissionCompetences.BankSlip.Taxes[0].TaxType.Id == 1 ? 'percentage' : 'currency'" />
                      <div class="invalid-feedback d-block invalid-tax" v-if="validatedTax">
                        {{ errors[0] }}
                      </div>
                    </ValidationProvider>
                  </d-col>
                  <d-col align-self="end" class="small">
                    <div>
                      <span>Valor mínimo de 
                        <span style="font-weight: bold;">{{ CommissionCompetences.BankSlip.Labels[0] }}</span>
                      </span>
                      <br>
                      <span>Valor máximo de 
                        <span style="font-weight: bold;">{{ CommissionCompetences.BankSlip.Labels[CommissionCompetences.BankSlip.Labels.length - 1] }}</span>
                      </span>
                    </div>
                  </d-col>
                  <d-col class="text-right mr-2">
                    <p class="h5" style="color: green; font-weight: bold;">{{ LinkBankSlipCommission | percentage }}</p>
                  </d-col>
                </d-form-row>
              </div>

              <div class="mb-5 pt-3">
                <d-form-row>
                  <d-col>
                    <label class="h5">{{ CommissionCompetences.CreditCard.Name }}</label>
                  </d-col>
                  <d-col class="text-right">
                    <span class="h5">Comissão</span>
                  </d-col>
                </d-form-row>
                <d-form-row align-v="start">
                  <d-col md="3">
                    <label class="mb-0 tax-type">{{ CommissionCompetences.CreditCard.Taxes[0].TaxType.Id == 1 ? "Percentual (%)" : "Valor (R$)" }}</label>
                    <ValidationProvider 
                      :rules="{
                        required: true,
                        min_percentage: parseFloat(CommissionCompetences.CreditCard.Labels[0].replace(',', '.')),
                        max_percentage: parseFloat(CommissionCompetences.CreditCard.Labels[CommissionCompetences.CreditCard.Labels.length - 1].replace(',', '.')),
                      }" v-slot="{ errors, invalid }"
                    >
                      <decimal-field v-model="CreditCardTax" id="CreditCard" :disabled="isSeeing" class="link" :class="validatedTax | showValidateError(invalid)"
                        :type="CommissionCompetences.CreditCard.Taxes[0].TaxType.Id == 1 ? 'percentage' : 'currency'" />
                      <div class="invalid-feedback d-block invalid-tax" v-if="validatedTax">
                        {{ errors[0] }}
                      </div>
                    </ValidationProvider>
                  </d-col>
                  <d-col align-self="end" class="small">
                    <div>
                      <span>Valor mínimo de 
                        <span style="font-weight: bold;">{{ CommissionCompetences.CreditCard.Labels[0] }}</span>
                      </span>
                      <br>
                      <span>Valor máximo de 
                        <span style="font-weight: bold;">{{ CommissionCompetences.CreditCard.Labels[CommissionCompetences.CreditCard.Labels.length - 1] }}</span>
                      </span>
                    </div>
                  </d-col>
                  <d-col class="text-right mr-2">
                    <p class="h5" style="color: green; font-weight: bold;">{{ LinkCreditCardCommission | percentage }}</p>
                  </d-col>
                </d-form-row>
              </div>

              <div class="mb-5 pt-3">
                <d-form-row>
                  <d-col class="text-left">
                    <label class="h5">{{ CommissionCompetences.Pix.Name }}</label>
                  </d-col>
                  <d-col class="text-right">
                    <span class="h5">Comissão</span>
                  </d-col>
                </d-form-row>
                <d-form-row>
                  <d-col md="3">
                    <label class="mb-0 tax-type">{{ CommissionCompetences.Pix.Taxes[0].TaxType.Id == 1 ? "Percentual (%)" : "Valor (R$)" }}</label>
                    <ValidationProvider 
                      :rules="{
                        required: true,
                        min_value: parseFloat(CommissionCompetences.Pix.Labels[0].replace(',', '.')),
                        max_value: parseFloat(CommissionCompetences.Pix.Labels[CommissionCompetences.Pix.Labels.length - 1].replace(',', '.')),
                      }" v-slot="{ errors, invalid }"
                    >
                      <decimal-field v-model="PixTax" id="Pix" class="link" :disabled="isSeeing" :class="validatedTax | showValidateError(invalid)"
                        :type="CommissionCompetences.Pix.Taxes[0].TaxType.Id == 1 ? 'percentage' : 'currency'" />
                      <div class="invalid-feedback d-block invalid-tax" v-if="validatedTax">
                        {{ errors[0] }}
                      </div>
                    </ValidationProvider>
                  </d-col>
                  <d-col align-self="end" class="small">
                    <div>
                      <span>Valor mínimo de 
                        <span style="font-weight: bold;">{{ CommissionCompetences.Pix.Labels[0] }}</span>
                      </span>
                      <br>
                      <span>Valor máximo de 
                        <span style="font-weight: bold;">{{ CommissionCompetences.Pix.Labels[CommissionCompetences.Pix.Labels.length - 1] }}</span>
                      </span>
                    </div>
                  </d-col>
                  <d-col class="text-right mr-2">
                    <p class="h5" style="color: green; font-weight: bold;">{{ LinkPixCommission | percentage }}</p>
                  </d-col>
                </d-form-row>
              </div>

              <div class="mb-5 pt-3" v-if="IsCommercial">
                <d-form-row>
                  <d-col>
                    <label class="h5">{{ CommissionCompetences.Anticipation.Name }}</label>
                  </d-col>
                  <d-col class="text-right">
                    <span class="h5">Comissão</span>
                  </d-col>
                </d-form-row>
                <d-form-row align-v="start">
                  <d-col md="3">
                    <label class="mb-0 tax-type">{{ CommissionCompetences.Anticipation.Taxes[0].TaxType.Id == 1 ? "Percentual (%)" : "Valor (R$)" }}</label>
                    <ValidationProvider 
                      :rules="{
                        required: true,
                        min_percentage: parseFloat(CommissionCompetences.Anticipation.Labels[0].replace(',', '.')),
                        max_percentage: parseFloat(CommissionCompetences.Anticipation.Labels[CommissionCompetences.Anticipation.Labels.length - 1].replace(',', '.')),
                      }" v-slot="{ errors, invalid }"
                    >
                      <decimal-field v-model="AnticipationTax" id="CreditCard" :disabled="isSeeing" class="link" :class="validatedTax | showValidateError(invalid)"
                        :type="CommissionCompetences.Anticipation.Taxes[0].TaxType.Id == 1 ? 'percentage' : 'currency'" />
                      <div class="invalid-feedback d-block invalid-tax" v-if="validatedTax">
                        {{ errors[0] }}
                      </div>
                    </ValidationProvider>
                  </d-col>
                  <d-col align-self="end" class="small">
                    <div>
                      <span>Valor mínimo de 
                        <span style="font-weight: bold;">{{ CommissionCompetences.Anticipation.Labels[0] }}</span>
                      </span>
                      <br>
                      <span>Valor máximo de 
                        <span style="font-weight: bold;">{{ CommissionCompetences.Anticipation.Labels[CommissionCompetences.Anticipation.Labels.length - 1] }}</span>
                      </span>
                    </div>
                  </d-col>
                  <d-col class="text-right mr-2">
                    <p class="h5" style="color: green; font-weight: bold;">{{ LinkAnticipationCommission | percentage }}</p>
                  </d-col>
                </d-form-row>
              </div>

            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>
      <template slot="modal-footer" slot-scope="{cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="AddLinkValidated()"
          v-if="!isSeeing || isCreating"
        >
          {{isCreating == false ? "Salvar" : "Adicionar"}}
          <i class="fas fa-arrow-right"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            placeholder="Descrição"
            type="text"
            class="form-control"
            v-model="filter.Description"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IdUserPartner" :value="null">
            <option :value="null" selected>Vendedor</option>
            <option :value="0" selected>Sem vendedor</option>
            <option v-for="user in users" v-bind:key="user.Id" v-bind:value="user.Id">{{user.Name}}</option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo link"
      v-on:click="OpenMLink($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import rangeSlider from "../common/range-slider";
import { setTimeout } from "timers";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
import decimalField from "../common/decimal-field.vue";

export default {
  name: "links",
  components: {
    rangeSlider,
    decimalField,
    popper: Popper
  },
  data: function() {
    return {
      loadingLinkList: false,
      loadingModal: false,
      validatedFormValidation: false,
      textPopper: "",
      textCopied: "Copiado!",
      textToCopy: "Clique para copiar!",
      textCopyFailed: "Falha ao copiar. Tente novamente =( ",
      countFilter: 0,
      filter: {
        Description: null,
        IdUserPartner: null
      },
      PartnerLink: {
        Id: 0,
        Description: "",
        UserPartner: {
          Id: 0
        },
        ComissionCompetences: []
      },
      bRange: {
        labels: ["R$ 1,96", "R$ 1,83", "R$ 1,55"],
        min: 1,
        max: 3,
        value: 1
      },
      pOpened: null,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      validatedTax: true,
      ListLinks: [],
      isSeeing: false,
      isCreating: false,
      modalTitle: "Novo link",
      users: [],
      isDataReady: false
    };
  },
  computed: {
    IsCommercial() {
      return this.$partnerTypeCode() === "1";
    },
    CommissionCompetences() {
      return this.$store.getters.CommissionCompetence;
    },
    LinkBankSlipCommission: {
      get() { return this.$store.getters.LinkBankSlipCommission },
      set(value) { this.$store.commit("SET_LINK_BANKSLIP_COMMISSION", value) }
    },
    LinkCreditCardCommission: {
      get() { return this.$store.getters.LinkCreditCardCommission },
      set(value) { this.$store.commit("SET_LINK_CREDITCARD_COMMISSION", value) }
    },
    LinkPixCommission: {
      get() { return this.$store.getters.LinkPixCommission },
      set(value) { this.$store.commit("SET_LINK_PIX_COMMISSION", value) }
    },
    LinkAnticipationCommission: {
      get() { return this.$store.getters.LinkAnticipationCommission },
      set(value) { this.$store.commit("SET_LINK_ANTICIPATION_COMMISSION", value) }
    },
  },
  watch: {
    "pagination.PageNumber": function() {
      this.ListLink();
    },
    "pagination.RowsPerPage": function() {
      this.ListLink();
    },
    CommissionCompetences: function() {
      const numCommissionCompetences = Object.keys(this.CommissionCompetences).length;
      if (numCommissionCompetences > 0) {
        this.isDataReady = true;
      }
    }
  },
  mounted() {
    this.ListUserPartner();
    this.ListLink();
    $('[data-toggle="tooltip"]').tooltip();
    this.textPopper = this.textToCopy;
    this.$requestGetCommissionCompetence();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListLink();
    },
    ResetFilter: function() {
      this.filter = {
        Description: null,
        IdUserPartner: null
      };
      this.ListLink();
    },
    ListLink: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.Description)) this.countFilter++;
      if (hasValue(this.filter.IdUserPartner)) this.countFilter++;
      this.loadingLinkList = true;
      let self = this;
      let data = {
        ...this.pagination,
        ...{
          "Object.Description": this.filter.Description,
          "Object.UserPartner.Id": this.filter.IdUserPartner
        }
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListLink", { params: data })
        .then(
          response => {
            self.ListLinks = response.Objects;
            self.pagination.TotalItems = response.TotalItems;
          },
          error => {
            this.$makeToast(
              "Não foi possível listar os links",
              "danger",
              "Listagem dos Links",
              error
            );
          }
        )
        .finally(() => {
          this.loadingLinkList = false;
        });
    },
    ListUserPartner: function() {
      let data = {
        ...{
          "Object.UserProfilePartner.Code": 2,
          "PageNumber": 0,
          "RowsPerPage": 0,
        },
      };
      this.$store
        .dispatch("ListUser", { params: data })
        .then(response => {
          this.users = response.Objects;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter lista de usuários",
            error
          );
        });
    },
    CopyLink: function(e) {
      e.preventDefault();

      e.target.focus();

      var textArea = document.createElement("textarea");
      textArea.value = e.target.textContent;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        let successful = document.execCommand("copy");
        if (successful) this.textPopper = this.textCopied;
        else this.textPopper = this.textCopyFailed;
      } catch (err) {
        this.textPopper = this.textCopyFailed;
      }
      textArea.remove();
    },
    ResetPopperText: function() {
      setTimeout(() => {
        this.textPopper = this.textToCopy;
      }, 40);
    },
    RemoveLinkValidate(linkId) {
      this.$makeMsgBox(
        "Você tem certeza que deseja remover o link?",
        "Confirmar",
        this.RemoveLink,
        linkId
      );
    },
    RemoveLink: function(id) {
      this.$store.dispatch("DeleteLink", { id: id }).then(
        () => {
          this.$makeToast(
            `O link foi removido com sucesso`,
            "success",
            "Remoção de Link"
          );
          this.FeedbackModal();
        },
        error => {
          this.$makeToast(
            "Não foi possível remover o link",
            "danger",
            "Remoção de Link",
            error
          );
          this.FeedbackModal();
        }
      );
    },
    FeedbackModal() {
      this.ListLink();
      this.$bvModal.hide("mFormLink");
    },
    GetLink: function(e, id, seeing) {
      e.preventDefault();
      this.ResetInfoLink();
      let self = this;
      this.loadingModal = true;
      this.isCreating = false;
      this.validatedFormValidation = false;
      this.$bvModal.show("mFormLink");

      this.$store
        .dispatch("GetLink", { id: id })
        .then(response => {
          self.PartnerLink.Id = response.Id;
          self.PartnerLink.Description = response.Description;
          self.PartnerLink.CreatedDate = response.CreatedDate;
          self.PartnerLink.UserPartner = response.UserPartner;

          const commissionCompetences = response.ComissionCompetences;

          for (const commission of commissionCompetences) {
            const paymentMethod = commission.PaymentMethod.Code;
            switch (paymentMethod) {
              case "1":
                self.$store.commit("SET_LINK_BANKSLIP_COMMISSION", commission.Commission);
                self.BankSlipTax = commission.Tax;
                break;
              case "2":
                self.$store.commit("SET_LINK_CREDITCARD_COMMISSION", commission.Commission);
                self.CreditCardTax = commission.Tax;
                break;
              case "6":
                self.$store.commit("SET_LINK_PIX_COMMISSION", commission.Commission);
                self.PixTax = commission.Tax;
                break;
              case "15":
                self.$store.commit("SET_LINK_ANTICIPATION_COMMISSION", commission.Commission);
                self.AnticipationTaxTax = commission.Tax;
                break;
            };

            if (typeof seeing != "undefined") {
              self.isSeeing = true;
              self.modalTitle = "Detalhes do Link";
            } else {
              self.isSeeing = false;
              self.modalTitle = "Editar Link";
            }
          }
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    OpenMLink: function() {
      this.ResetInfoLink();
      this.modalTitle = "Novo Link";
      this.isCreating = true;
      this.validatedFormValidation = false;
      this.$bvModal.show("mFormLink");
    },
    ResetInfoLink: function() {
      this.isSeeing = false;
      this.PartnerLink.Description = "";
      this.PartnerLink.UserPartner.Id = 0;

      const avaiablePaymentMethods = ["BankSlip", "CreditCard", "Pix", "Anticipation"];
      for (const method of avaiablePaymentMethods) {
        const numberOfTaxes = this.CommissionCompetences[method].Taxes.length;
        const highestTax = this.CommissionCompetences[method].Taxes[numberOfTaxes - 1].Tax;
        if (method == "BankSlip") {
          this.BankSlipTax = highestTax;
        }
        if (method == "CreditCard") {
          this.CreditCardTax = highestTax;
        }
        if (method == "Pix") {
          this.PixTax = highestTax;
        }
        if (method == "Anticipation") {
          this.AnticipationTax = highestTax;
        }

        const commission = this.CommissionCompetences[method].Taxes[numberOfTaxes - 1].Commission;
        const PAYMENT_METHOD = method.toUpperCase();
        this.$store.commit("SET_LINK_" + PAYMENT_METHOD + "_COMMISSION", commission);
      }
    },
    AddLinkValidated: function() {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then(valid => {
        if (valid) {
          this.AddLink();
        }
      });
    },
    AddLink: function() {
      const self = this;
      this.loadingModal = true;

      this.PartnerLink.ComissionCompetences = [];

      const bankSlipId = this.CommissionCompetences.BankSlip.Taxes.filter(commission => commission.Commission == this.LinkBankSlipCommission)[0].Id;
      const creditCardId = this.CommissionCompetences.CreditCard.Taxes.filter(commission => commission.Commission == this.LinkCreditCardCommission)[0].Id;
      const pixId = this.CommissionCompetences.Pix.Taxes.filter(commission => commission.Commission == this.LinkPixCommission)[0].Id;
      const anticipationId = this.CommissionCompetences.Anticipation.Taxes.filter(commission => commission.Commission == this.LinkAnticipationCommission)[0].Id;
      const antiFraudId = this.CommissionCompetences.AntiFraud.Taxes[0].Id;
      const smsId = this.CommissionCompetences.Sms.Taxes[0].Id;


      const bankSlipCommissionCompetence = { Id: bankSlipId, Tax: this.BankSlipTax };
      const creditCardCommissionCompetence = { Id: creditCardId, Tax: this.CreditCardTax };
      const pixCommissionCompetence = { Id: pixId, Tax: this.PixTax };
      const anticipationCommissionCompetence = { Id: anticipationId, Tax: this.AnticipationTax };
      const smsCommissionCompetence = { Id: antiFraudId, Tax: this.CommissionCompetences.AntiFraud.Taxes[0].Tax };
      const antiFraudeCommissionCompetence = { Id: smsId, Tax: this.CommissionCompetences.Sms.Taxes[0].Tax };

      this.PartnerLink.ComissionCompetences.push(bankSlipCommissionCompetence);
      this.PartnerLink.ComissionCompetences.push(creditCardCommissionCompetence);
      this.PartnerLink.ComissionCompetences.push(pixCommissionCompetence);
      this.PartnerLink.ComissionCompetences.push(anticipationCommissionCompetence);
      this.PartnerLink.ComissionCompetences.push(smsCommissionCompetence);
      this.PartnerLink.ComissionCompetences.push(antiFraudeCommissionCompetence);

      if (this.$partnerTypeCode() == "1") {
        const anticipationId = this.CommissionCompetences.Anticipation.Taxes.filter(commission => commission.Commission == this.LinkAnticipationCommission)[0].Id;
        const anticipationCommissionCompetence = { Id: anticipationId, Tax: this.AnticipationTax };
      this.PartnerLink.ComissionCompetences.push(anticipationCommissionCompetence);
      }

      if (self.isCreating) {
        //Add;
        this.$store
          .dispatch("AddLink", this.PartnerLink)
          .then(() => {
            self.ListLink();
            this.$bvModal.hide("mFormLink");
            self.$makeToast(
              "Sucesso ao criar o link",
              "success",
              "Criação de Link"
            );
          })
          .catch(error => {
            self.$makeToast(
              "Não foi possível criar o link",
              "danger",
              "Criação de Link",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      } else {
        //Update;
        this.$store
          .dispatch("UpdateLink", this.PartnerLink)
          .then(() => {
            self.ListLink();
            this.$bvModal.hide("mFormLink");
            self.$makeToast(
              "Sucesso ao alterar o link",
              "success",
              "Alteração de Link"
            );
          })
          .catch(error => {
            self.$makeToast(
              "Não foi possível alterar o link",
              "danger",
              "Alteração de Link",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    }
  }
};
</script>

<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.cursor-pointer {
  cursor: pointer;
}
.tax-box .method-name {
  float: left;
  margin-top: 20px;
  font-weight: 600;
}
.tax-box .commission-value {
  float: right;
  text-align: center;
}
.tax-box .commission-value span {
  display: block;
  color: green;
  font-size: 12pt;
  font-weight: 600;
}
.invalid-tax {
  position: absolute;
  font-weight: bold;
  font-size: 0.7rem;
}
.tax-type {
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/links.vue